import { orgCompositionInternalTagsUrl } from '../urls';
import refresh from '../refresh';

export async function postOrgCompositionTag(orgId, compId, tagId) {
  const data = {
    org: orgId,
    comp: compId,
    tag: tagId,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionInternalTagsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function deleteOrgCompositionTag(orgId, compId, tagId) {
  const data = {
    org: orgId,
    comp: compId,
    tag: tagId,
  };
  return refresh(async () => {
    const response = await fetch(orgCompositionInternalTagsUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
